import React from "react";

import { Grid } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import FieldView from "../../../../../../../../components/Form/FieldView";
import { ItemJob } from "../../../../../../../../models/sales";

interface Props {
  itemJob: ItemJob;
}

export const ItemDetail = ({ itemJob }: Props) => {
  const { t: translate } = useTranslation();

  const getLocation = (): { location: string; storageBox: string; map: string } => {
    const storageBoxes = itemJob?.storageBoxes;

    if (storageBoxes && storageBoxes?.length > 0) {
      const boxNumber = storageBoxes?.[0]?.number;
      const mapCell = storageBoxes?.[0]?.mapCells?.[0];
      const map = mapCell?.map;

      return {
        location: mapCell?.name || "",
        storageBox: boxNumber,
        map: map?.name || "",
      };
    }

    const mapCells = itemJob?.mapCells;

    if (mapCells && mapCells?.length > 0) {
      const mapCell = mapCells?.[0];
      const map = mapCell?.map;

      return {
        location: mapCell?.name || "",
        storageBox: translate("none"),
        map: map?.name || "",
      };
    }

    return {
      location: "",
      storageBox: translate("none"),
      map: "",
    };
  };

  const getLastMoved = (): string => {
    const { lastMovedAt } = itemJob;

    return lastMovedAt ? format(new Date(lastMovedAt), "dd/MM/yyyy p") : "";
  };

  const location = getLocation();

  return (
    <Grid>
      <Grid container direction="row" spacing={3}>
        <Grid item md={3}>
          <FieldView
            label={translate("order")}
            value={itemJob?.job?.reference}
            data-cy="field-view-order"
          />
        </Grid>

        <Grid item md={3}>
          <FieldView
            label={translate("storageBox")}
            value={location.storageBox}
            data-cy="field-view-inside-storage-box"
          />
        </Grid>

        <Grid item md={3}>
          <FieldView
            label={translate("location")}
            value={`${location.map} - ${location.location}`}
            data-cy="field-view-location"
          />
        </Grid>

        <Grid item md={3}>
          <FieldView
            label={translate("lastMoved")}
            value={getLastMoved()}
            data-cy="field-view-last-moved"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
